<template>
  <v-app>
    <v-toolbar app color="white" height="80" clipped-left>
      <v-toolbar-side-icon
        @click.stop="drawer = !drawer"
        class="hidden-md-and-up"
        v-show="$auth.check()"
      ></v-toolbar-side-icon>
      <v-toolbar-title class="headline text-uppercase">
        <v-layout class="xs12">
          <img src="./assets/ng_logo2.svg" height="60" />
        </v-layout>
      </v-toolbar-title>

      <v-toolbar-items
        v-for="item in itemsUser"
        :key="item.name"
        class="hidden-sm-and-down ml-4"
        v-show="$auth.check(2)"
      >
        <v-btn color="primary" :to="item.name" dark flat>
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>

      <v-toolbar-items
        v-for="item in itemsAdmin"
        :key="item.name"
        class="hidden-sm-and-down ml-4"
        v-show="$auth.check(1)"
      >
        <v-btn color="primary" :to="item.name" dark flat>
          <v-icon left dark>{{ item.icon }}</v-icon>
          {{ item.title }}
        </v-btn>
      </v-toolbar-items>
      <v-spacer></v-spacer>
      <!-- <div class="title">Testovací prostředí</div> -->
      <v-spacer></v-spacer>
      <v-toolbar-title class="primary--text subheading">
        {{ $auth.user().Name }}
      </v-toolbar-title>
      <v-toolbar-items class="hidden-sm-and-down" v-show="!$auth.check()">
        <v-btn color="primary" :to="'/login'" dark flat>
          <v-icon left dark>key</v-icon>
          {{ $t('login') }}
        </v-btn>
      </v-toolbar-items>
      <v-toolbar-items class="hidden-sm-and-down" v-show="$auth.check()">
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn color="primary" fab dark v-on="on" flat large>
              <v-icon>account_circle</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-tile
              v-for="(item, index) in userMenu"
              :key="index"
              :to="item.name"
            >
              <v-list-tile-avatar>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile>

            <v-list-tile @click="$auth.logout()">
              <v-list-tile-avatar>
                <v-icon>power_settings_new</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-title>{{ $t('logout') }}</v-list-tile-title>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-toolbar-items>
    </v-toolbar>
    <v-navigation-drawer
      v-model="drawer"
      temporary
      absolute
      width="200"
      id="drawer"
    >
      <v-list class="pb-4" dense>
        <v-list-tile>
          <v-list-tile-avatar>
            <v-icon color="primary" large>account_circle</v-icon>
          </v-list-tile-avatar>
          <v-list-tile-content>
            <v-list-tile-title>
              <strong>{{ $auth.user().Name }}</strong>
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile
          :to="item.name"
          v-for="item in itemsUser"
          :key="item.title"
          v-show="$auth.check(2)"
          @click.stop="drawer = !drawer"
        >
          <v-list-tile-action>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title color="primary">
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile
          :to="item.name"
          v-for="item in itemsAdmin"
          :key="item.title"
          v-show="$auth.check(1)"
          @click.stop="drawer = !drawer"
        >
          <v-list-tile-action>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title color="primary">
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-list class="pt-0" dense>
        <v-divider></v-divider>
        <v-list-tile
          :to="item.name"
          v-for="item in userMenu"
          :key="item.title"
          @click.stop="drawer = !drawer"
        >
          <v-list-tile-action>
            <v-icon color="primary">{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title color="primary">
              {{ item.title }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile @click="$auth.logout()">
          <v-list-tile-action>
            <v-icon>power_settings_new</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title color="primary">{{
              $t('logout')
            }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>

    <v-content>
      <router-view />
    </v-content>
    <Footer />
    <error-dialog ref="gerror" />
    <loader ref="loader" />
  </v-app>
</template>

<script>
import Footer from './components/Footer'
import ErrorDialog from './components/ErrorDialog'
import Loader from './components/Loader'
export default {
  name: 'App',
  components: {
    ErrorDialog,
    Loader,
    Footer
  },
  data() {
    return {
      error: false,
      drawer: false,
      itemsUser: [
        {
          title: this.$t('cash_registers'),
          icon: 'assignment',
          name: '/ecrmregistration'
        },
        {
          title: this.$t('products'),
          icon: 'list',
          name: '/products'
        },
        {
          title: this.$t('services_mgmt'),
          icon: 'shopping_basket',
          name: '/services_mgmt'
        },
        {
          title: this.$t('online_services'),
          icon: 'device_hub',
          name: '/online_services'
        }
      ],
      itemsAdmin: [
        {
          title: this.$t('dealers_mgmt'),
          icon: 'face',
          name: '/dealers_mgmt'
        },
        {
          title: this.$t('online_services'),
          icon: 'device_hub',
          name: '/online_services'
        }
        //{ title: this.$t('profile'), icon: "account_circle", name: "profile" }
      ],
      userMenu: [
        {
          title: this.$t('profile'),
          icon: 'account_circle',
          name: '/editprofile'
        },
        { title: this.$t('pwd_change'), icon: 'lock', name: '/changepassword' },
        { title: this.$t('invoices'), icon: 'payment', name: '/invoices' }
      ]
    }
  },
  mounted() {
    this.$root.$gerror = this.$refs.gerror.show
    this.$root.$loader = this.$refs.loader.show
  }
}
</script>
